module.exports = __webpack_public_path__ + "weathericons-regular-webfont.4618f0de2a818e7ad3fe.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/weather-icons/font/weathericons-regular-webfont.ttf
// module id = 499
// module chunks = 3